import { IndustrialProcessSchema, IndustrialProcessType } from "../types";

export const isChimicalProcess = (industrialProcess: IndustrialProcessType) =>
  industrialProcess === IndustrialProcessSchema.enum.CHIMIC_ENGRAVING;
